module.exports = __webpack_public_path__ + "img/zanwuhetong.e4944ad3.png";